var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBmiGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_15434",
    "data-name": "Group 15434",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29.907,
    height: 19.5,
    viewBox: "0 0 29.907 19.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16144",
    "data-name": "Rectangle 16144",
    width: 29.907,
    height: 19.5,
    fill: "#72d54a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15433",
    "data-name": "Group 15433",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41214",
    "data-name": "Path 41214",
    d: "M14.026,0h1.868a1.744,1.744,0,0,0,.253.054,13.691,13.691,0,0,1,5.328,1.438,14.823,14.823,0,0,1,8.2,10.853c.1.512.155,1.033.231,1.55V16a1.81,1.81,0,0,0-.054.191c-.143.841-.266,1.685-.431,2.522a.88.88,0,0,1-.989.789H1.492A.9.9,0,0,1,.5,18.744,14.876,14.876,0,0,1,4.2,4.586,14.555,14.555,0,0,1,12.76.169C13.181.106,13.6.056,14.026,0m1.055,15.832a2.762,2.762,0,0,0,.565-.355c.878-.853,1.739-1.724,2.6-2.593a.872.872,0,1,0-1.228-1.225c-.5.5-1,1-1.506,1.5-.392.392-.79.778-1.172,1.179a.818.818,0,0,0-.167.967.959.959,0,0,0,.9.524m.754-10.023c0-.272.008-.545,0-.817a.873.873,0,1,0-1.746,0q-.018.8,0,1.6a.873.873,0,1,0,1.746,0c.01-.262,0-.525,0-.787M5.8,15.823c.262,0,.525.006.787,0A.874.874,0,1,0,6.6,14.073c-.525-.011-1.05-.01-1.575,0a.875.875,0,1,0-.012,1.748c.262.009.525,0,.787,0m18.288,0c.272,0,.545.007.817,0a.875.875,0,1,0-.01-1.748c-.525-.009-1.05-.011-1.575,0a.874.874,0,1,0,.01,1.748c.253.007.506,0,.758,0M20.841,6.332a.914.914,0,0,0-.631-.848.838.838,0,0,0-.988.359c-.28.455-.542.92-.806,1.384a.872.872,0,1,0,1.5.872c.251-.426.5-.853.74-1.287a3.66,3.66,0,0,0,.184-.48m1.395,5.309a.984.984,0,0,0,.294-.076c.526-.29,1.055-.58,1.564-.9a.861.861,0,0,0-.848-1.491c-.533.278-1.053.582-1.564.9a.844.844,0,0,0-.334.977.88.88,0,0,0,.887.59M11.655,7.675a.985.985,0,0,0-.076-.3c-.3-.534-.588-1.073-.917-1.587a.859.859,0,0,0-1.475.867c.278.533.582,1.053.9,1.564a.842.842,0,0,0,.976.336.881.881,0,0,0,.593-.884M6.409,9.1a.868.868,0,0,0-.914.6.84.84,0,0,0,.367.985c.481.292.967.577,1.46.847a.872.872,0,0,0,1.171-.313.858.858,0,0,0-.29-1.175c-.487-.3-.986-.582-1.487-.859A1.128,1.128,0,0,0,6.409,9.1",
    transform: "translate(0)",
    fill: "#72d54a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBmiGreen);
export default __webpack_public_path__ + "static/media/bmi-green.038e05b70c7547d5e2800f7847bf15e0.svg";
export { ForwardRef as ReactComponent };